import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from 'scenes/ProjectForms/utils/getCredentials';
import setDeleteForm from 'scenes/ProjectForms/utils/setDeleteForm';
import { loadProjectBankFormsFolderContents } from './loadProjectBankFormsFolderContents.thunk';

export const deleteProjectBankForm = createAsyncThunk(
  'projectBank/deleteProjectBankForm',
  async (filePermission, { dispatch, rejectWithValue }) => {
    const formId = filePermission?.sourceFormId;
    const projectId =
      typeof filePermission?.project === 'object'
        ? filePermission?.project?.id
        : filePermission?.project;

    if (!formId || !projectId) {
      return rejectWithValue({ message: 'Missing formId or projectId' });
    }

    try {
      const { accessKeyId, secretAccessKey, sessionToken } =
        await getCredentials();

      const response = await setDeleteForm(
        { id: formId, project: projectId },
        { accessKeyId, secretAccessKey, sessionToken }
      );

      // delete-form.ts cascades to a linked measurement_report_attachment
      // when the parent is a substation_commissioning_inspection_report —
      // refetch so the local form list reflects all server-side deletions.
      await dispatch(loadProjectBankFormsFolderContents(projectId));

      return { fileId: filePermission.id, projectId, response };
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data ||
        error?.message ||
        'Unknown error';
      return rejectWithValue({ message });
    }
  }
);
